var React = require('react');

function ContactArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M137.515 0.893442L147.061 10.4394C147.646 11.0252 147.646 11.9749 147.061 12.5607L137.515 22.1066C136.929 22.6924 135.979 22.6924 135.393 22.1066C134.808 21.5209 134.808 20.5711 135.393 19.9853L142.379 13H0V10H142.379L135.393 3.01476C134.808 2.42898 134.808 1.47923 135.393 0.893442C135.979 0.307655 136.929 0.307655 137.515 0.893442Z","fill":"#003AFF"}));
}

ContactArrow.defaultProps = {"width":"148","height":"23","viewBox":"0 0 148 23","fill":"none"};

module.exports = ContactArrow;

ContactArrow.default = ContactArrow;
